// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useYieldCallback } from '@zillow/yield-callback';

// Lodash
import includes from 'lodash/includes';

// Misc / utils
import { BlurbLink } from './styles';

export const useBlurbLinks = ({ name, areaType, resourceId, searchSlug, houseOrApartment }) => {
  const schoolTypes = ['primaryschool', 'middleschool', 'mixedschool', 'highschool', 'university', 'unifschdist'];
  const isInSchoolZone = includes(schoolTypes, areaType);
  const yieldTransitionTo = useYieldCallback((href) => {
    window.router.transitionTo(href);
  });

  const handleLinkClick = (e, href) => {
    // Prevent the browser from going through with its default <a> behavior
    e.preventDefault();

    yieldTransitionTo(href);
  };

  const createLink = ({ anchorText, href }) => {
    // HPWEB-6229: Rm links from school zone SRPs
    return isInSchoolZone ? (
      anchorText
    ) : (
      <BlurbLink linkType="underline" href={href} onClick={(e) => handleLinkClick(e, href)}>
        {anchorText}
      </BlurbLink>
    );
  };

  const blurbLinks = {
    area: createLink({ anchorText: name, href: `/${resourceId}/${searchSlug}` }),
    default: createLink({
      anchorText: name,
      href: `/${resourceId}/${houseOrApartment === 'apartment' ? 'apartments-for-rent' : 'houses-for-rent'}`,
    }),
    petFriendly: createLink({
      anchorText: 'pet friendly',
      href: `/${resourceId}/pet-friendly-${houseOrApartment}s-for-rent`,
    }),
    withInUnitLaundry: createLink({
      anchorText: 'in-unit laundry',
      href: `/${resourceId}/apartments-for-rent-with-laundry`,
    }),
    withAc: createLink({
      anchorText: 'A/C',
      href: `/${resourceId}/${houseOrApartment}s-for-rent?amenities=cooling`,
    }),
    withGym: createLink({
      anchorText: 'on-site gym',
      href: `/${resourceId}/${houseOrApartment}s-for-rent-with-gym`,
    }),
    withParking: createLink({
      anchorText: 'available parking',
      href: `/${resourceId}/${houseOrApartment}s-for-rent-with-parking`,
    }),
    withPromo: createLink({
      anchorText: '"Promo" tag',
      href: `/${resourceId}/${houseOrApartment}s-for-rent?promo=true`,
    }),
    affordablePads: createLink({
      anchorText: `cheap ${name} ${houseOrApartment}s`,
      href: `/${resourceId}/affordable-${houseOrApartment}s-for-rent`,
    }),
    luxuryPads: createLink({
      anchorText: `luxury ${houseOrApartment}`,
      href: `/${resourceId}/luxury-${houseOrApartment}s-for-rent`,
    }),
  };

  return [blurbLinks];
};
